'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefault(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefault(_objectWithoutProperties);

var _excluded = ["title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty__default.default(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ErrorIcon = function ErrorIcon(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Error' : _ref$title,
    props = _objectWithoutProperties__default.default(_ref, _excluded);
  return /*#__PURE__*/jsxRuntime.jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    title: title,
    role: "img"
  }, props), {}, {
    children: [/*#__PURE__*/jsxRuntime.jsx("title", {
      children: title
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M12,1 C5.92510019,1 1,5.92490769 1,12 C1,18.0750923 5.92510019,23 12,23 C18.0750923,23 23,18.0750923 23,12 C23,5.92490769 18.0750923,1 12,1 Z M12,20.7082932 C7.19078452,20.7082932 3.29170677,16.809793 3.29170677,12 C3.29170677,10.0580649 3.92791768,8.26550934 5.00244999,6.81714296 L17.1830495,18.997935 C15.7346832,20.0720823 13.9419351,20.7082932 12,20.7082932 Z M18.9977425,17.1826645 L6.81714296,5.00225749 C8.26531684,3.92772518 10.0582574,3.29151427 12,3.29151427 C16.8096005,3.29151427 20.7084857,7.19078452 20.7084857,11.9998075 C20.7084857,13.9417426 20.0722748,15.7348757 18.9977425,17.1826645 Z"
    })]
  }));
};
ErrorIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ErrorIcon",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Error'",
        "computed": false
      },
      "required": false
    }
  }
};
var ErrorIcon$1 = ErrorIcon;

exports.default = ErrorIcon$1;
//# sourceMappingURL=ErrorIcon.js.map
